// CE-124 — Report Permission Configuration (FE)
// Types mirror the locked backend contract (group-shaped GET/dump, roleIds-only PATCH/load).

export enum ReportRoleType {
  ACADEMIC_UNIT = 'academic_unit',
  COURSE_SECTION = 'course_section'
}

export enum ReportAccess {
  FULL_ACCESS = 'full_access',
  VIEW_RESULTS_ONLY = 'view_results_only',
  NO_ACCESS = 'no_access'
}

export enum QuestionType {
  QUANTITATIVE = 'quantitative',
  QUALITATIVE = 'qualitative'
}

/** Option object for the Visible Question Types multi-select (R2). */
export interface QuestionTypeOption {
  id: QuestionType
  label: string
}

/** Scope the modal is configuring. */
export type ReportPermissionScope = 'series' | 'slot'

/** Role option returned by `/report_permissions/roles/` and embedded in group dumps. */
export interface ReportPermissionRole {
  roleId: string
  roleName: string
  roleType?: string
}

/** Group as returned by GET / save response (camelCased on the wire). */
export interface ReportPermissionGroup {
  groupId: string
  roleType: ReportRoleType
  roles: ReportPermissionRole[]
  reportAccess: ReportAccess
  visibleQuantitative: boolean
  visibleQualitative: boolean
  canViewTaResults: boolean
}

/** PATCH payload group — server generates `groupId`; the FE sends role ids only. */
export interface ReportPermissionGroupPayload {
  roleType: ReportRoleType
  roleIds: string[]
  reportAccess: ReportAccess
  visibleQuantitative: boolean
  visibleQualitative: boolean
  canViewTaResults?: boolean
}

/**
 * One editable card in the form. `roles` and `questionTypes` hold full option objects
 * (the multi-selects store objects). The two R2 booleans are derived from `questionTypes`
 * at payload time.
 */
export interface PermissionCardForm {
  /** Present for groups loaded from the server (render-only; never sent back). */
  groupId?: string
  roleType: ReportRoleType | ''
  roles: ReportPermissionRole[]
  reportAccess: ReportAccess
  questionTypes: QuestionTypeOption[]
  canViewTaResults: boolean
}

export interface ReportPermissionsFormData {
  cards: PermissionCardForm[]
}

/** Per-card validation messages (empty object = valid). */
export interface CardError {
  roles?: string
  questionTypes?: string
}
